/* eslint-disable no-dupe-keys */
export default {
  parking_relief_code: {
    name: '停车减免二维码',
    // 属性（一般与对象内容匹配）
    prop: {
      charge_station: '充电站',
      relief_code: '停车码',
      description: '描述',
      used_time: '使用时间',
      plate_number: '车牌',
      created_at: '创建时间',
      updated_at: '更新时间'
    },
    // 列表页字段（列控制使用，需要与列表页匹配）
    columns: {
      wechat_unionid: '微信unionid',
      charge_station: '充电站',
      service_provider: '运营商',
      user: '用户',
      order: '订单',
      relief_code: '停车码',
      status: '状态',
      description: '描述',
      used_time: '使用时间',
      created_at: '创建时间',
      updated_at: '更新时间'
    },
    // Enum的属性
    statuses: {
      available: '可用',
      used: '已使用'
    },
    group_titles: {
      base: '基本信息'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询充电站名字/车牌'
    },
    dialog: {
      delete: '删除选中',
      delete_title: '删除停车减免二维码',
      delete_content: '确定要删除选中的停车减免二维码吗？'
    }
    // 详情页标签
  }
}
